module.exports = __webpack_public_path__ + "img/goods_05.013f2ee6.jpg";